import { EErrorNotificationActionType } from './types';
import { EErrorNotificationType } from '../../types/notifications';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const pushErrorNotification = actionGenerator<EErrorNotificationActionType.Pushed, EErrorNotificationType>(
  EErrorNotificationActionType.Pushed,
);
